export default __webpack_public_path__ + "static/media/white_right_arrow.aabc16bc.svg";